export default "__VITE_ASSET__518fab62__"